<template lang="pug">
div
  label.btn.btn-action.btn-link(
    :for="id"
    :class="{disabled: uploading}"
  )
    i.fa.fa-paperclip
    |  Adicionar imagens
  input.input-files(type="file" :id="id" @input="onChangeFiles" multiple accept="image/*,application/pdf")
  div(v-if="thumbs.length")
    .divider
    h5.h5 Fila de upload
    .upload-list
      .bg-gray.s-rounded.my-2.py-2(v-for="thumb, index in thumbs")
        .columns
          .column.col-auto
            figure.avatar
              img.bg-gray(:src='thumb')
          .column.text-ellipsis.text-small
            .text-ellipsis {{ files[index].name }}
            div.text-gray {{ files[index].size / 1024 | currency('', ' kb') }}
            progress.progress(:value="progress" max="100" v-if="currentIndex == index && !done")
            .text-error(v-else-if="errors[index]") {{ errors[index].message }}
          .column.col-auto.flex-centered.mr-2.text-small
            i.fa.fa-exclamation-circle.text-error(v-if="errors[index]")
            i.fa.fa-check-circle.text-primary(v-else-if="done || currentIndex > index")
            .text-small(v-else-if="currentIndex == index") {{ progress }}%
  div(v-if="value.length")
    .divider
    h5.h5 Novas Plantas
    .columns
      .column.col-auto.pb-2(v-for='planta in value' :key='planta.id')
        figure.avatar.avatar-xl
          img.bg-gray(:src='planta.thumb')
</template>

<script>
import OsmPlanta from "@/models/OsmPlanta"

export default {
  vuex: {
    uploads: {
      actions: ["fetchUploadMultiple"],
      state: [
        "uploading",
        "files",
        "currentIndex",
        "progress",
        "done",
        "errors",
      ],
      mutations: ["setFiles", "resetState", "setUploaded"],
    },
  },
  props: {
    value: { type: Array, required: true },
    id: { default: "files" },
  },
  data() {
    return { thumbs: [] }
  },
  watch: {
    files() {
      this.thumbs = []
      if (this.files && Object.keys(this.files).length > 0) {
        for (const file of this.files) {
          const reader = new FileReader()
          reader.onload = e =>
            this.thumbs.push(
              file.type === "application/pdf"
                ? "/img/pdf_icon.png"
                : e.target.result,
            )
          reader.readAsDataURL(file)
        }
      }
    },
  },
  methods: {
    async onChangeFiles({ target: { files } }) {
      this.resetState()
      this.setFiles(files)
      const uploaded = await this.fetchUploadMultiple({ files })
      const plantas = uploaded.map(
        item =>
          new OsmPlanta({
            id: item.id,
            url: item.url,
            url_square: item.url_square,
            thumb: item.thumb,
            nome: item.file_name,
          }),
      )
      this.setUploaded([...this.value, ...plantas])
    },
  },
}
</script>

<style lang="stylus" scoped>
.input-files
  position absolute
  left -100vw
  opacity 0

.progress
  max-width 50%

.upload-list
  max-height 300px
  overflow-y auto
  overflow-x hidden
</style>
